export default __webpack_public_path__ + "static/media/reward-image.6258b6ab.png";